// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cr-j";
export var fulfillmentFormRail = "_cr-i";
export var headerTitleRow = "_cr-l";
export var orderDetailsWrapper = "_cr-g";
export var orderLinkTrigger = "_cr-2";
export var paymentInformationGrid = "_cr-q";
export var paymentSummaryColumn = "_cr-r";
export var phoneShipmentPickerButton = "_cr-e";
export var phoneShipmentPickerButtonContent = "_cr-f";
export var phoneShipmentPickerButtonWrapper = "_cr-d";
export var phoneShipmentPickerTrigger = "_cr-c";
export var shipmentContainer = "_cr-k";
export var shipmentDetailsMainPane = "_cr-h";
export var shipmentNavigationCard = "_cr-a";
export var shipmentNavigationEdgeTrigger = "_cr-6";
export var shipmentNavigationRail = "_cr-3";
export var shipmentNavigationRailEnter = "_cr-5";
export var shipmentNavigationRailHeader = "_cr-9";
export var shipmentNavigationRailOverlay = "_cr-4";
export var shipmentNavigationScrim = "_cr-7";
export var shipmentSummaryFact = "_cr-n";
export var shipmentSummaryGrid = "_cr-m";
export var shipmentSummaryMetadataRow = "_cr-o";
export var shipmentSummaryTags = "_cr-p";
export var shipmentWorkspace = "_cr-0";
export var shipmentWorkspaceBodyTablet = "_cr-8";
export var shipmentWorkspaceContent = "_cr-b";
export var shipmentWorkspaceHeader = "_cr-1";